import React from "react";
import { CheckCircle2, Landmark } from "lucide-react";

const eur = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

export default function VirementDone({ order, devisSent, onClose }) {
  const { bank } = order;
  return (
    <div className="flex-1 overflow-y-auto p-6 text-center" data-testid="virement-done">
      <CheckCircle2 size={48} className="text-[#D8B86A] mx-auto mb-3" />
      <h3 className="font-heading text-xl font-bold text-[#072135] mb-1">Commande enregistrée</h3>
      <p className="text-sm text-[#4B5563] mb-4">N° <strong data-testid="virement-numero">{order.numero}</strong> — un email récapitulatif vous a été envoyé.</p>
      <div className="text-left bg-[#F9F9F9] border border-gray-200 rounded-sm p-4 space-y-1.5 text-sm mb-4">
        <div className="flex items-center gap-2 font-bold text-[#072135] mb-1"><Landmark size={15} className="text-[#D8B86A]" /> Virement à effectuer</div>
        <div className="flex justify-between"><span>Montant</span><strong data-testid="virement-total">{eur.format(order.total)}</strong></div>
        <div className="flex justify-between"><span>Référence</span><strong>{order.numero}</strong></div>
        {bank?.iban ? (
          <>
            <div className="flex justify-between gap-2"><span>Titulaire</span><span className="font-mono-tech text-xs text-right">{bank.titulaire}</span></div>
            <div className="flex justify-between gap-2"><span>IBAN</span><span className="font-mono-tech text-xs text-right break-all" data-testid="virement-iban">{bank.iban}</span></div>
            <div className="flex justify-between gap-2"><span>BIC</span><span className="font-mono-tech text-xs">{bank.bic}</span></div>
          </>
        ) : (
          <p className="text-xs text-[#4B5563]">Nos coordonnées bancaires vous sont envoyées par email.</p>
        )}
      </div>
      <p className="text-xs text-[#4B5563] mb-5">Vos pièces sont préparées dès réception du virement.{devisSent ? " Votre demande de devis pour les autres articles a aussi été envoyée." : ""}</p>
      <button onClick={onClose} className="lmb-btn-primary" data-testid="virement-close">Fermer</button>
    </div>
  );
}
